const BASE = 6100;
const STEP = 10;

let depth = 0;

export const layerStack = {
  push(): number {
    depth += 1;
    return BASE + depth * STEP;
  },
  pop(): void {
    if (depth > 0) depth -= 1;
  },
  peek(): number {
    return BASE + depth * STEP;
  },
};
